// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3kI8t","vLegacy":"SelectSecondary_vLegacy__3NRlk","error":"SelectSecondary_error__1Vjby","disabled":"SelectSecondary_disabled__2YOGx"};